import { render, staticRenderFns } from "./OpeningHoursInput.vue?vue&type=template&id=f32d69ae&"
import script from "./OpeningHoursInput.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports